var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCircleArrowDown = function SvgCircleArrowDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ABBABD",
    d: "M7 20a13 13 0 1 1 26 0 13 13 0 0 1-26 0m29 0a16 16 0 1 0-32 0 16 16 0 0 0 32 0m-23-4v9.5c0 .832.669 1.5 1.5 1.5h10c.831 0 1.5-.668 1.5-1.5 0-.83-.669-1.5-1.5-1.5h-6.381l8.444-8.437a1.494 1.494 0 0 0 0-2.119 1.5 1.5 0 0 0-2.12 0l-8.437 8.438V16c0-.83-.668-1.5-1.5-1.5-.831 0-1.5.67-1.5 1.5z"
  })));
};
export default SvgCircleArrowDown;